import React from 'react';

import { compose } from 'redux';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  DASHBOARD_URL,
  INFLUENCERS_URL,
  JOB_LIST_URL,
  UNISSU_EVENTS_URL
} from 'global-constants';

import WithUser from 'shared/HOCs/WithUser';
import WithPush from 'shared/HOCs/WithPush';
import WithOpenModal from 'shared/HOCs/WithOpenModal';

import {
  HoverTooltip,
  DesktopHoverTooltip
} from 'shared/components/HoverTooltip';
import { MOBILE_NAV_CONTENT } from 'shared/components/Navigation/MobileNav/constants';

import { setActiveTab } from 'pages/EditProfile/ducks';

import ExternalLink from 'shared/components/ExternalLink';
import VisibleIfUserIsLogged from 'shared/components/VisibleIfUserIsLogged';

import Tenders from './Tenders';
import Directory from './Directory';
import ContentLibrary from './ContentLibrary';
import DirectoryDropdown from './DirectoryDropdown';
import TendersDropdown from './TendersDropdown';
import ContentLibraryDropdown from './ContentLibraryDropdown';
import { checkIfActive } from './utils';
import { SECTION_TO_URL_MAPPING } from './constants';

import homeIcon from './assets/home.svg';

import styles from './styles.module.scss';

class NavLinks extends React.Component {
  handleTooltipClick = content => {
    // We're doing this because thic action is only passed in Mobile.
    if (this.props.openAction) this.props.openAction(content);
  };

  render() {
    return (
      <div className={classnames(this.props.wrapperClassname, styles.links)}>
        <VisibleIfUserIsLogged>
          <NavLink
            id="navigation-home"
            className={classnames('remove-sm', styles.link, styles.icon)}
            to={DASHBOARD_URL}
            activeClassName={styles.active}
            onClick={this.props.closeNavigation}>
            <img src={homeIcon} alt="home" />
          </NavLink>
          <NavLink
            id="mobile-navigation-home"
            className={classnames(styles.link, 'remove-md-min')}
            to={DASHBOARD_URL}
            activeClassName={styles.active}
            onClick={this.props.closeNavigation}>
            Dashboard
          </NavLink>
        </VisibleIfUserIsLogged>

        <DesktopHoverTooltip
          className="remove-sm"
          active={checkIfActive(SECTION_TO_URL_MAPPING.TENDERS)}
          tooltip={<TendersDropdown />}>
          Procurement
        </DesktopHoverTooltip>

        <HoverTooltip
          className="remove-md-min"
          tooltip={<Tenders />}
          onClick={() => this.handleTooltipClick(MOBILE_NAV_CONTENT.TENDERS)}
          active={checkIfActive(SECTION_TO_URL_MAPPING.TENDERS)}>
          <a
            href="# "
            className={classnames({
              [styles.active]: checkIfActive(SECTION_TO_URL_MAPPING.TENDERS)
            })}>
            Procurement
          </a>
        </HoverTooltip>

        <DesktopHoverTooltip
          className="remove-sm"
          active={checkIfActive(SECTION_TO_URL_MAPPING.DIRECTORY)}
          tooltip={<DirectoryDropdown />}>
          Directories
        </DesktopHoverTooltip>

        <HoverTooltip
          className="remove-md-min"
          tooltip={<Directory />}
          onClick={() => this.handleTooltipClick(MOBILE_NAV_CONTENT.DIRECTORY)}
          active={checkIfActive(SECTION_TO_URL_MAPPING.DIRECTORY)}>
          <a
            href="# "
            className={classnames({
              [styles.active]: checkIfActive(SECTION_TO_URL_MAPPING.DIRECTORY)
            })}>
            Directories
          </a>
        </HoverTooltip>
        <NavLink
          id="navigation-influencers"
          className={styles.link}
          to={INFLUENCERS_URL}
          activeClassName={styles.active}
          onClick={this.props.closeNavigation}>
          Influencers
        </NavLink>

        <DesktopHoverTooltip
          className="remove-sm"
          active={checkIfActive(SECTION_TO_URL_MAPPING.CONTENT_LIBRARY)}
          tooltip={<ContentLibraryDropdown />}>
          Content Library
        </DesktopHoverTooltip>
        <HoverTooltip
          className="remove-md-min"
          tooltip={<ContentLibrary />}
          onClick={() =>
            this.handleTooltipClick(MOBILE_NAV_CONTENT.CONTENT_LIBRARY)
          }
          active={checkIfActive(SECTION_TO_URL_MAPPING.CONTENT_LIBRARY)}>
          <a
            href="# "
            className={classnames({
              [styles.active]: checkIfActive(
                SECTION_TO_URL_MAPPING.CONTENT_LIBRARY
              )
            })}>
            Content Library
          </a>
        </HoverTooltip>

        <NavLink
          id="navigation-jobs"
          className={styles.link}
          activeClassName={styles.active}
          to={JOB_LIST_URL}
          onClick={this.props.closeNavigation}>
          Jobs
        </NavLink>
      </div>
    );
  }
}

export default compose(
  connect(
    null,
    { setActiveTab }
  ),
  WithUser,
  WithPush,
  WithOpenModal
)(NavLinks);
export { Directory, Tenders, ContentLibrary };
